import React from 'react';
import { Box, IconButton } from '@mui/material';
import { StudioFlowColors } from '../studioFlowTheme';

interface SocialLoginButtonsProps {
  onGoogle: () => void;
  disabled?: boolean;
}

export const SocialLoginButtons: React.FC<SocialLoginButtonsProps> = ({
  onGoogle,
  disabled = false,
}) => (
  <Box sx={{ display: 'flex', justifyContent: 'center', gap: 6 }}>
    <IconButton
      aria-label="Continue with Google"
      onClick={onGoogle}
      disabled={disabled}
      sx={{
        width: 56,
        height: 56,
        border: `1px solid ${StudioFlowColors.unfocused}`,
        bgcolor: StudioFlowColors.background,
        '&.Mui-disabled': {
          bgcolor: StudioFlowColors.disabled,
          color: StudioFlowColors.disabledText,
        },
      }}
    >
      <Box
        component="img"
        src={`${process.env.PUBLIC_URL}/images/google-g-logo.png`}
        alt=""
        aria-hidden="true"
        sx={{
          width: 28,
          height: 28,
          display: 'block',
        }}
      />
    </IconButton>
  </Box>
);
